import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import journeys from "../static/data/journeys.js";
import amritsar from "../static/images/amritsar.jpg";
import kerala from "../static/images/kerela.jpg";
import kashmir from "../static/images/kashmir.jpg";
import ladakh from "../static/images/ladakh.jpg";
import bentota from "../static/images/product/bentota/bentota_main.png";
import nuwara from "../static/images/product/nuwara/nuwara_main.png";
import kandy from "../static/images/product/kandy/kandy_main.png";
import triangle from "../static/images/product/triangle/triangle_main.jpg";
import bhutan from "../static/images/product/bhutan/bhutan_main.png";
import "../sass/layout/_destination.scss";
import India from "../static/videos/desktop/india_dest.mp4";
import SriLanka from "../static/videos/desktop/sri_lanka_dest.mp4";
import Bhutan from "../static/videos/desktop/bhutan_dest.mp4";
import IndiaMobile from "../static/videos/mobile/india_dest_phone.mp4";
import SriLankaMobile from "../static/videos/mobile/sri_lanka_dest_phone.mp4";
import BhutanMobile from "../static/videos/mobile/bhutan_dest_phone.mp4";
import "../sass/layout/_signatureJourneys.scss";
import { NewJourneyCard } from "../components/journeyCard.js";
import "../sass/layout/_experiences.scss";
import "../sass/base/_typogrophy.scss";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import LazyImage from "../components/LazyImage.js";
import { ProductNew } from "./ProductNew.js";

const VIDEOS = {
  India,
  SriLanka,
  Bhutan,
};

const VIDEOS_MOBILE = {
  IndiaMobile,
  SriLankaMobile,
  BhutanMobile,
};
const imgs = {
  kerala,
  kashmir,
  amritsar,
  ladakh,
  nuwara,
  kandy,
  bentota,
  triangle,
  bhutan
};

export const Destination = ({ hideDestinationHeading }) => {
  const [details, setDetails] = useState(null);
  const { destination } = useParams();
  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  const isBhutanPage = destination.slice(1).toLowerCase() === "bhutan";
  const videoRef = useRef(null);


  const [highlightedIndex, setHighlightedIndex] = React.useState(null);

  useEffect(() => {
    setDetails(journeys.find((dest) => destination.slice(1) === dest.country));
    window.scrollTo(0, 0);
  }, [destination]);

  const destinationDetails = React.useMemo(() => {
    if (!details) return null;
    return (
      <div>
        <div className="destination-container-left-upper">
          <h1
            className="cu-heading"
            style={{
              display: hideDestinationHeading ? "none" : "inherit",
              width: isBhutanPage && width < 600 ? "90%" : "100%"
            }}
          >
            {details.destinationIntro}
          </h1>
          <LazyImage
            component={
              <video
                videoRef={videoRef}
                playsInline
                preload="auto"
                style={{
                  width: "100%",
                  height: width < 600 && isBhutanPage ? "60vh" : width < 600 ? "80vh" : "inherit",
                  borderRadius: "1rem",
                  objectFit: width < 600 && "cover"
                }}
                src={
                  width > 600
                    ? VIDEOS[destination.slice(1)]
                    : VIDEOS_MOBILE[destination.slice(1) + "Mobile"]
                }
                autoPlay
                muted
                loop
              />
            }
          />
        </div>
      </div>
    );
  }, [destination, details, hideDestinationHeading, isBhutanPage, width]);

  const renderCards = React.useMemo(() => {
    if (!details) return null;
    return details.tours.map((dest, index) => {
      const shouldHighlight = highlightedIndex === index;
      return (
        <NewJourneyCard
          navToFunction={() => {
            navigate("/book", {
              state: {
                country: destination.slice(1),
                destination: dest.destination,
              },
            });
          }}
          shouldRenderEnquireButton={dest.attractions !== "Coming Soon"}
          navTo={`/:${destination.slice(1)}/:${dest.destination}`}
          key={index}
          dest={dest}
          img={imgs[dest.img_filename]}
          setHighlightedIndex={setHighlightedIndex}
          shouldHighlight={shouldHighlight}
          index={index}
        />
      );
    });
  }, [details, highlightedIndex, destination, navigate]);

  return (
    <>

      <div className="destination-container">
        {destinationDetails}
      </div>


      {isBhutanPage ?
        <>
          <div style={{ height: "5vh" }} />
          <ProductNew />
        </>
        : (
          <div style={{ marginTop: width < 600 && "2rem" }} className="signature-journeys-container">
            <div className="sj-card-container" id="scrollbar-style">
              {renderCards}
            </div>
            <div className="scrollbar-container">
            </div>
          </div>
        )}
    </>
  );
};